var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#25d366;}.cls-2,.cls-3{fill:#fff;}.cls-3{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WhatsApp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Background",
    className: "cls-1",
    d: "M831,103.2c0-48.65,0-73,15.11-88.09S885.55,0,934.2,0h8.6c48.65,0,73,0,88.09,15.11S1046,54.55,1046,103.2v8.6c0,48.65,0,73-15.11,88.09S991.45,215,942.8,215h-8.6c-48.65,0-73,0-88.09-15.11S831,160.45,831,111.8Z",
    transform: "translate(-831)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "WhatsApp-2",
    "data-name": "WhatsApp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "WhatsApp-3",
    "data-name": "WhatsApp",
    className: "cls-2",
    d: "M880.57,166.37l8.3-30.32a58.51,58.51,0,1,1,50.7,29.3h0a58.38,58.38,0,0,1-27.95-7.12ZM913,147.64l1.78,1.05a48.5,48.5,0,0,0,24.75,6.78h0a48.62,48.62,0,1,0-41.2-22.79l1.16,1.84-4.91,17.95Z",
    transform: "translate(-831)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "WhatsApp-4",
    "data-name": "WhatsApp",
    className: "cls-3",
    d: "M969,120.76c-.36-.61-1.34-1-2.8-1.71s-8.65-4.27-10-4.75-2.31-.74-3.29.73-3.77,4.75-4.63,5.73-1.7,1.1-3.16.37a40.29,40.29,0,0,1-11.76-7.26,44.05,44.05,0,0,1-8.13-10.13c-.85-1.46-.09-2.25.64-3s1.46-1.71,2.19-2.56a10,10,0,0,0,1.46-2.44,2.67,2.67,0,0,0-.12-2.56c-.36-.73-3.29-7.93-4.5-10.86s-2.4-2.46-3.29-2.51-1.83,0-2.81,0A5.38,5.38,0,0,0,915,81.61a16.41,16.41,0,0,0-5.12,12.2c0,7.19,5.24,14.14,6,15.12s10.31,15.74,25,22.07a81.77,81.77,0,0,0,8.34,3.08,19.86,19.86,0,0,0,9.2.58c2.81-.42,8.65-3.53,9.87-7S969.41,121.37,969,120.76Z",
    transform: "translate(-831)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/WhatsApp.16ac8a7e467a74b2acb72a1af760f7d7.svg";
export { ForwardRef as ReactComponent };